export const ACCESS_TO_ANALYST = 'ACCESS_TO_ANALYST';
export const ADVANCED_PEOPLE_MANAGEMENT = 'ADVANCED_PEOPLE_MANAGEMENT';
export const ALERTS = 'ALERTS';
export const AXA_MY_TRIP = 'AXA_MY_TRIP';
export const CATEGORIES = 'CATEGORIES';
export const CLIENT_BRANDING = 'CLIENT_BRANDING';
export const CLIENT_CONFIGURED_RISK_RATINGS = 'CLIENT_CONFIGURED_RISK_RATINGS';
export const CLIENT_CUSTOMIZATIONS = 'CLIENT_CUSTOMIZATIONS';
export const CRISIS_SIGNAL_LOCATION_MANAGEMENT = 'CRISIS_SIGNAL_LOCATION_MANAGEMENT';
export const CRITICAL_OUTREACH = 'CRITICAL_OUTREACH';
export const CUSTOM_RATING_SCALE = 'CUSTOM_RATING_SCALE';
export const DESKTOP_ALERTING = 'DESKTOP_ALERTING';
export const DIB = 'DIB';
export const DIRECT_MESSAGE_MANAGEMENT = 'DIRECT_MESSAGE_MANAGEMENT';
export const E_LEARNING = 'E_LEARNING';
export const EXPATRIATIONS = 'EXPATRIATION_MANAGEMENT';
export const EXPOSURE_CHECK = 'EXPOSURE_CHECK';
export const EXPOSURE_CHECK_SITES = 'EXPOSURE_CHECK_SITES';
export const FACEBOOK_INTEGRATION = 'FACEBOOK_INTEGRATION';
export const HEALTH_OUTLOOK = 'HEALTH_OUTLOOK';
export const HOTLINE = 'HOTLINE';
export const IMG_MEDICAL_NETWORK = 'IMG_MEDICAL_NETWORK';
export const IN_APP_MESSAGING = 'IN_APP_MESSAGING';
export const INTERNAL_CONFERENCE_BRIDGE = 'INTERNAL_CONFERENCE_BRIDGE';
export const KEYWORDS = 'KEYWORDS';
export const LARGE_SCALE_EVENT_ANALYSIS = 'LARGE_SCALE_EVENT_ANALYSIS';
export const LGBTQ_SECURITY_OUTLOOK = 'PRISM';
export const LOCATION_INTEL = 'LOCATION_INTEL';
export const LOCATION_RATINGS = 'LOCATION_RATINGS';
export const LOCATIONS = 'LOCATIONS';
export const MASS_NOTIFICATION = 'MASS_NOTIFICATION';
export const MOBILE_LOCATION_SHARING_RISK_MANAGEMENT = 'MOBILE_LOCATION_SHARING_RISK_MANAGEMENT';
export const MS_TEAMS_INTEGRATION = 'MS_TEAMS_INTEGRATION';
export const OCCUPANTS = 'OCCUPANTS';
export const PEOPLE_MANAGEMENT = 'PEOPLE_MANAGEMENT';
export const PHYSICAL_SECURITY_INTEGRATION = 'PHYSICAL_SECURITY_INTEGRATION';
export const POST_BOOKING_APPROVAL = 'POST_BOOKING_APPROVAL';
export const QUOTA_MESSAGES = 'QUOTA_MESSAGES';
export const SAFETY_CHECKIN_LOCATION_MANAGEMENT = 'SAFETY_CHECKIN_LOCATION_MANAGEMENT';
export const SCHEDULED_TRAVELER_CHECK_IN = 'SCHEDULED_TRAVELER_CHECK_IN';
export const SECURITY_OUTLOOK = 'SECURITY_OUTLOOK';
export const SERVICENOW_INTEGRATION = 'SERVICENOW_INTEGRATION';
export const SITE_POINTS_OF_CONTACT = 'SITE_POINTS_OF_CONTACT';
export const SITES_MANAGEMENT = 'SITES_MANAGEMENT';
export const SLACK_INTEGRATION = 'SLACK_INTEGRATION';
export const THREAT_ZONES = 'THREAT_ZONES';
export const TRIP_EMAIL_PARSING = 'TRIP_EMAIL_PARSING';
export const TRIP_MANAGEMENT = 'TRIP_MANAGEMENT';
export const WORLD_AIRLINE_MONITOR = 'WORLD_AIRLINE_MONITOR';
export const X_INTEGRATION = 'X_INTEGRATION';
export const ADDRESS_LOCATION_MANAGEMENT = 'ADDRESS_LOCATION_MANAGEMENT';
export const ACCESS_POINTS = 'ACCESS_POINTS';
